import {strings} from "../strings/strings";

export enum DocumentType {
	PASSPORT = "PASSPORT",
	DRIVER_LICENSE = "DRIVER_LICENSE",
	RESIDENCE_PERMIT = "RESIDENCE_PERMIT"
}

export const DocumentTypeMap: Record<string, string> = {
	"PASSPORT": strings.documentTypePassport,
	"DRIVER_LICENSE": strings.documentTypeDriverLicense,
	"RESIDENCE_PERMIT": strings.documentTypeResidencePermit
};

export interface Document {
	documentType: DocumentType;
	number: string;
	issueOrganization: string;
	issueDate: Date;
}